// The Apps & MCP page's toasts, placed like the chat's own.
export const TOAST_OPTIONS = { position: "bottom-right", autoClose: 5000, theme: "light" };
